module.exports = __webpack_public_path__ + "img/icon_perfil_maestro_card.dbea449f.svg";